<template>
  <el-popover
    placement="top"
    title="补偿金额计算"
    width="560"
    @hide="hidePopover"
    ref="popoverRef"
    trigger="click">
    <div class="tool-box">
      <el-form :inline="true" ref="queryFrom" :model="queryFrom" :rules="rules">
        <el-form-item label="差价订单" prop="orderId">
          <el-input class="w-240" v-model.trim="queryFrom.orderId" placeholder="请输入订单号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="queryData()">查询</el-button>
        </el-form-item>
      </el-form>
      <div class="goods-wrapper" v-if="itemData.length">
        <table class="googs_table">
            <tbody v-for="(item,index) in itemData" :key="index">
              <tr>
                <td>
                  <div class='elradio'>
                    <el-radio 
                      v-model="subObrderId"
                      :label="item.subOrderId"
                      v-show="!item.tuDetails"
                      @change="handleChange()">
                    </el-radio>
                    <i 
                      class="el-icon-caret-bottom" 
                      :class="{'active': !item.isTuShow}" 
                      v-if="item.tuDetails" 
                      @click="item.isTuShow = !item.isTuShow">
                    </i>
                  </div>
                  <div class="goods-info-wrapper">
                    <div class="info-wrapper-flex">
                      <img :src="item.itemImg" alt="">
                      <div class="goods-info">
                        <h4><span>{{item.itemName}}</span><label>￥{{item.itemPrice}}</label></h4>
                        <p><span>规格：{{item.itemModel}}</span><label>x{{item.buyCount}}</label>
                        </p>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-for='(itemT,indexT) in item.tuDetails' :key='indexT' v-show='item.tuDetails && item.isTuShow'>
                <td>
                  <div class='elradio'>
                    <el-radio v-model="subObrderId" :label="itemT.subOrderId" @change="handleChange()"></el-radio>
                  </div>
                  <div class="goods-info-wrapper">
                    <div class="info-wrapper-flex">
                      <img :src="itemT.itemImg" alt="">
                      <div class="goods-info">
                        <h4><span>{{itemT.itemName}}</span><label>￥{{itemT.itemPrice}}</label></h4>
                        <p><span>规格：{{itemT.itemModel}}</span><label>x{{itemT.buyCount}}</label>
                        </p>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>    
      </div>
      <div class="tool-box" v-if="calcData.calcText">
        <div class="tool-text">{{calcData.calcText}}</div>
        <div class="tool-text">
          <span>{{calcData.calcNumText}}</span>
        </div>
        <el-button type="primary" @click="fillAmount()">填入</el-button>
      </div>
      <div class="error-tips" v-if="errorMsg">{{errorMsg}}</div>
    </div>
    <i class="box-right-money" slot="reference">金额计算</i>
  </el-popover>
</template>
<script type="text/ecmascript-6" >
import * as http from './compensate.service'

export default {
  props: {
    orgOrderId: {
      type: String,
      default: ''
    },
    orgSubOrderId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      itemData: [], // 根据订单号查询出来的商品信息
      queryFrom: {
        orderId: '' 
      },
      subObrderId: '',
      rules: {
        orderId: [
          { required: true, message: '请输入订单号进行查询', trigger: 'blur' }
        ]
      },
      calcData: {},
      errorMsg: ''
    }
  },
  methods: {
    // 隐藏popover
    hidePopover() {
      this.itemData = ''
      this.subObrderId = ''
      this.queryFrom.orderId = ''
      this.calcData = {}
      this.errorMsg = ''
    },
    // 查询订单数据
    queryData() {
      this.$refs.queryFrom.validate((valid) => {
        if (valid) {
          http.preViewCompensateOrderItem({
            compensateType: 1,
            receiptNo: this.queryFrom.orderId,
            businessDomain: 0
          }).subscribe((res) => {
            if (res.data.orderItemBo && res.data.orderItemBo.length) {
              res.data.orderItemBo.forEach((item) => {
                item.isTuShow = false
              })
              this.itemData = res.data.orderItemBo
            }
          })
        }
      })
    },
    handleChange() {
      const params = {
        orgOrderId: this.orgOrderId,
        orgSubOrderId: this.orgSubOrderId,
        orderId: this.queryFrom.orderId,
        subObrderId: this.subObrderId
      }
      this.errorMsg = ''
      http.priceGuaranteeToolCalc(params, { errorMsg: 'none' }).subscribe((res) => {
        this.calcData = res.data || {}
      },
      (err) => {
        this.errorMsg = err.responseText
        this.calcData = {}
      })
    },
    // 填入金额
    fillAmount() {
      this.$emit('fillAmount', this.calcData.amount)
      this.$refs.popoverRef.doClose()
    }
  }
}
</script>
<style lang="less" scoped>
.tool-box {
  padding:10px 10px;
  .tool-text {
    margin-bottom: 16px;
  }
}
.error-tips{
  margin-top: 10px;
  color: #F10D3B;
}
.w-240 {
  width: 240px;
}
.goods-wrapper {
  position: relative;
  width: 400px;
  max-height: 180px;
  overflow: hidden;
  overflow-y: auto;
  border:1px solid #dcdcdc;
  padding:10px 10px;
  border-radius: 5px;
  margin-left: 80px;
  .googs_table {
    width: 100%;
    border-collapse: collapse;
    border: none;
    th {
      font-weight: bold;
    }
    td{
      display:flex;
      border-top:none!important;
      border-bottom: 1px solid #ccc;
      .elradio {
        width: 16px;
        display: flex;
        align-items: center;
        /deep/ .el-radio__label {
          display: none;
        }
        i{
          cursor:pointer;
          transition:all 0.2s ease;
        }
        .active{
          transform: rotate(-90deg);
        }
      }
      .goods-info-wrapper {
        flex: 1;
        padding:6px 6px 6px 0;
        .info-wrapper-flex {
          display: flex;
          img {
            width:50px;
            height:50px;
            margin:6px 10px 0;
            border: 1px solid #eee;
          }
          .goods-info {
            flex: 1;
            h4,p {
              margin: 0;
              padding-bottom: 6px;
              label {
                float: right;
              }
            }
          }
        }
      }
    }
    td,th {
      padding: 0px;
    }
  }
}
.box-right-money {
  font-style: inherit;
  color: #0066CC;
  float: right;
  cursor: pointer;
}
</style>
